import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useScroll } from 'react-use';
import { css, styled } from 'styled-components';
import { ScrollButton, buttonSize } from './ScrollButton';
import { useMeasure } from '../../../../play-core/hooks/use-measure';
import { hideScrollbar } from '../../../../play-core/styles/style-helper';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const HorizontalScroller = ({
  children,
  disableForViewport,
  activeElement
}) => {
  const scrollRef = useRef(null);
  const contentRef = useRef(null);
  const {
    width: scrollWidth
  } = useMeasure(scrollRef);
  const {
    width: contentWidth
  } = useMeasure(contentRef);
  const {
    x: scrollX
  } = useScroll(scrollRef);
  const [scrollSmooth, setScrollSmooth] = useState(false);
  const scrollRightBy = useCallback((amount, smooth) => {
    scrollRef.current?.scrollBy({
      top: 0,
      left: amount,
      behavior: smooth ? 'smooth' : 'auto'
    });
  }, []);
  useEffect(() => {
    if (activeElement && scrollWidth > 0) {
      const {
        left,
        right
      } = activeElement.getBoundingClientRect();
      if (left < buttonSize) {
        scrollRightBy(left - buttonSize, scrollSmooth);
      } else if (right > scrollWidth - buttonSize) {
        scrollRightBy(right - scrollWidth + buttonSize, scrollSmooth);
      }
      setScrollSmooth(true);
    }
  }, [activeElement, scrollWidth, scrollSmooth, scrollRightBy]);
  const scrollOffset = 20;
  const showLeftButton = scrollX > scrollOffset;
  const showRightButton = scrollX + scrollWidth + scrollOffset <= contentWidth;
  const scrollAmount = scrollWidth - 2 * buttonSize;
  return /*#__PURE__*/_jsxs(Container, {
    children: [/*#__PURE__*/_jsx(ScrollContainer, {
      ref: scrollRef,
      disableForViewport: disableForViewport,
      children: /*#__PURE__*/_jsx(ContentContainer, {
        ref: contentRef,
        disableForViewport: disableForViewport,
        children: children
      })
    }), showLeftButton && /*#__PURE__*/_jsx(ScrollButton, {
      direction: "left",
      onClick: () => scrollRightBy(-scrollAmount, true)
    }), showRightButton && /*#__PURE__*/_jsx(ScrollButton, {
      direction: "right",
      onClick: () => scrollRightBy(scrollAmount, true)
    })]
  });
};
const Container = styled.div.withConfig({
  displayName: "HorizontalScroller__Container",
  componentId: "sc-1madqrd-0"
})(["position:relative;"]);
const ScrollContainer = styled.div.withConfig({
  displayName: "HorizontalScroller__ScrollContainer",
  componentId: "sc-1madqrd-1"
})(["overflow-x:scroll;overflow-y:auto;", ";", ""], hideScrollbar(), props => props.disableForViewport && css`
      ${Viewports.for(props.disableForViewport)} {
        overflow-x: initial;
        overflow-y: initial;
      }
    `);
const ContentContainer = styled.div.withConfig({
  displayName: "HorizontalScroller__ContentContainer",
  componentId: "sc-1madqrd-2"
})(["display:inline-flex;", ""], props => props.disableForViewport && css`
      ${Viewports.for(props.disableForViewport)} {
        display: initial;
      }
    `);